export default "__VITE_ASSET__4hI3_RWQ__"